export default function supportPlanTemplatesReducer(state = [], action) {
  const { type, payload } = action;

  switch (type) {
    case "GET_SUPPORT_PLAN_TEMPLATES_INIT":
      return [];
    case "GET_SUPPORT_PLAN_TEMPLATES_SUCCESS":
      return payload;
    default:
      return state;
  }
}
